import Config from './Config';
import loadGoogleMapsAPI from 'load-google-maps-api'

export default class ProjectPage {
    constructor(props) {
        this.mapSelector = 'projectMap'
        this.initCarousel();
        this.initEvents();
        this.loadGoogleMaps();
    }

    initCarousel() {
        $('.project-carousel').carousel();
    }

    initEvents(){
        if(window.location.hash != ''){
            $('a[href="'+location.hash+'"]').tab('show')
        }

        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            e.preventDefault();
            if(window.history.pushState) {
                window.history.pushState(null, null, $(e.target).attr('href'));
            }
            else {
                location.hash = $(e.target).attr('href');
            }
            return false;
        })

        $('[href="#tabMap"]').on('shown.bs.tab', (event) => {
            this.maps.event.trigger(this.map, 'resize');
            this.map.setCenter(this.getMapLocation())
        });
    }

    loadGoogleMaps(){
         loadGoogleMapsAPI({
            language: $('#' + this.mapSelector).data('lang') || 'en',
            key: Config.getGoogleMapsApiKey()
         }).then((googleMaps) => {
            this.maps = googleMaps;
            this.initMap();
        }).catch((err) => {
            console.error(err)
        })
    }
    initMap(){

        this.map = new this.maps.Map(document.getElementById(this.mapSelector), {
          zoom: 12,
          center: this.getMapLocation()
        });

        var marker = new this.maps.Marker({
            position: this.getMapLocation(),
            map: this.map,
            icon: $('#' + this.mapSelector).data('marker-icon')
        });


        setTimeout(() => {
            Config.removePageLoader();
        }, 500)
    }

    getMapLocation(){
        return {
            lng: $('#' + this.mapSelector).data('lng') || 34.7699902,
            lat: $('#' + this.mapSelector).data('lat') || 32.0177322
        };
    }
}



// WEBPACK FOOTER //
// src/scripts/ProjectPage.js